<strong class="text-black">{{ billingAddress?.name || defaultName }}</strong
><br />
<div [innerHTML]="billingAddress | address : true"></div>
